import React, { useEffect, useRef, useState } from 'react';
import styles from './DragAndDrop.module.scss';

interface ComponentProps {
  children?: React.ReactElement;
  callback?: (files: File[]) => void;
}

const DragAndDrop = ({ children, callback }: ComponentProps): React.ReactElement => {
  const dropRef = useRef<HTMLDivElement>(null);
  const [dragCounter, setDragCounter] = useState(0);
  const [dragging, setDragging] = useState(false);

  const handleDragIn = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prevCount: number) => prevCount + 1);
    if (e?.dataTransfer?.items && e.dataTransfer.items.length > 0) {
      setDragging(true);
    }
  };
  const handleDragOut = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragCounter((prevCount: number) => prevCount - 1);
    if (dragCounter === 0) {
      setDragging(false);
    }
  };
  const handleDragOver = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDrop = (e: DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    if (e?.dataTransfer?.files && e.dataTransfer.files.length > 0) {
      callback && callback([...e.dataTransfer.files]);
      // e.dataTransfer.clearData();
      setDragCounter(0);
    }
  };

  useEffect(() => {
    if (dropRef?.current) {
      dropRef.current.addEventListener('dragenter', handleDragIn);
      dropRef.current.addEventListener('dragleave', handleDragOut);
      dropRef.current.addEventListener('dragover', handleDragOver);
      dropRef.current.addEventListener('drop', handleDrop);
    }
    return () => {
      if (dropRef?.current) {
        dropRef.current.removeEventListener('dragenter', handleDragIn);
        dropRef.current.removeEventListener('dragleave', handleDragOut);
        dropRef.current.removeEventListener('dragover', handleDragOver);
        dropRef.current.removeEventListener('drop', handleDrop);
        setDragCounter(0);
      }
    };
  }, []);

  return (
    <div ref={dropRef} className={styles.dropBox}>
      {children}
    </div>
  );
};

export default DragAndDrop;
